import { Directive, ElementRef, Renderer2, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[ncPulsating]'
})
export class PulsatingDirective implements OnInit {
  @Input() ncDuration = 1500; // ms
  @Input() ncColor = '#0096ff'; // 默认浅蓝色光晕
  @Input() ncSize = '8px'; // 最大光晕宽度

  private pulsatingContainer!: HTMLElement;
  private readonly animationName: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    // 为每个实例生成唯一的动画名称
    this.animationName = `ncPulse_${Math.random().toString(36).substr(2, 9)}`;
  }

  ngOnInit() {
    this.createPulsatingContainer();
  }

  private createPulsatingContainer() {
    this.pulsatingContainer = this.renderer.createElement('div');
    this.renderer.addClass(this.pulsatingContainer, 'pulsating-container');
    // 设置基础样式
    this.renderer.setStyle(this.pulsatingContainer, 'position', 'absolute');
    this.renderer.setStyle(this.pulsatingContainer, 'inset', '0');
    this.renderer.setStyle(this.pulsatingContainer, 'borderRadius', 'inherit');
    this.renderer.setStyle(this.pulsatingContainer, 'pointerEvents', 'none');
    this.renderer.setStyle(this.pulsatingContainer, 'zIndex', '-1');
    this.renderer.setStyle(this.pulsatingContainer, 'animation',
      `${this.animationName} ${this.ncDuration}ms ease-in-out infinite`);

    const elementPosition = this.el.nativeElement.style.position;
    if (!elementPosition || elementPosition === 'static') {
      this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    }

    // 添加关键帧动画样式
    const style = this.renderer.createElement('style');
    const keyframes = `
      @keyframes ${this.animationName} {
        0% {
          box-shadow: 0 0 0 0 ${this.ncColor};
        }
        50% {
          box-shadow: 0 0 0 ${this.ncSize} ${this.ncColor};
          opacity: 0.5;
        }
        100% {
          box-shadow: 0 0 0 0 ${this.ncColor};
        }
      }
    `;
    this.renderer.appendChild(style, this.renderer.createText(keyframes));
    this.renderer.appendChild(this.el.nativeElement, style);

    // 将容器添加到宿主元素中
    this.renderer.appendChild(this.el.nativeElement, this.pulsatingContainer);
  }
}